module.exports = __webpack_public_path__ + "img/image-mars.748179d1.png";